import {scriptonload} from '../modules/scriptonload';

var fb = function () {
	var init = function(){
		//VK.Widgets.Group("vk_groups", {mode: 0, width: "240", height: "300", color1: '141414', color2: 'ffffff', color3: '5B7FA6'}, 52241390);
	}

	//scriptonload('http://connect.facebook.net/ru_RU/sdk.js#xfbml=1&version=v2.5', init);



       (function(d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s); js.id = id;
            js.src = "//connect.facebook.net/ru_RU/sdk.js#xfbml=1&version=v2.5";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));



};

export {fb};